
const EmotionalFooterEn = () => {
  return (
    <footer className="bg-muted/10">
      {/* Quote Section */}
      <div className="section-padding text-center border-t border-muted">
        <div className="max-w-4xl mx-auto">
          <blockquote className="text-2xl md:text-4xl font-serif italic text-muted-foreground mb-4">
            "The best gift we can give our children is not just money, but the memories of those who loved them."
          </blockquote>
          <p className="text-sm text-muted-foreground">— Legatia Team</p>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-muted py-6">
        <div className="container mx-auto text-center text-sm text-muted-foreground">
          © {new Date().getFullYear()} Legatia. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default EmotionalFooterEn;
